<nav class="controls" [attr.aria-label]="'navigation.reading_navigation' | translate">
  @if (showControls) {
    <reader-core-previous-button
      class="item"
      [interfaceMode]="interfaceMode"
      [navigationType]="navigationType"
      [disabled]="disablePrevious$ | async"
      [chapterLabel]="previousChapterLabel$ | async"
      (reverse)="navigateByStep(-1)"
    ></reader-core-previous-button>
  }

  @if (showPosition) {
    <reader-core-position-indicator
      class="item"
      [lower]="pageNumber$ | async"
      [upper]="positionUpper$ | async"
    ></reader-core-position-indicator>
  }

  @if (showControls) {
    <reader-core-forward-button
      class="item"
      [interfaceMode]="interfaceMode"
      [navigationType]="navigationType"
      [disabled]="disableNext$ | async"
      [chapterLabel]="nextChapterLabel$ | async"
      (forward)="navigateByStep(1)"
    ></reader-core-forward-button>
  }
</nav>
